const C = (code, name, de, alt = []) => ({ code, name, de, alt });

export const COUNTRIES = [
  C("DE", "Germany", "Deutschland", ["deutschland"]), C("GB", "United Kingdom", "Vereinigtes Königreich", ["uk", "england", "scotland", "wales", "great britain", "großbritannien"]),
  C("US", "United States", "USA", ["usa", "america"]), C("SE", "Sweden", "Schweden"), C("AT", "Austria", "Österreich"), C("CH", "Switzerland", "Schweiz"),
  C("NL", "Netherlands", "Niederlande", ["holland"]), C("BE", "Belgium", "Belgien"), C("FR", "France", "Frankreich"), C("ES", "Spain", "Spanien"), C("IT", "Italy", "Italien"),
  C("IE", "Ireland", "Irland"), C("DK", "Denmark", "Dänemark"), C("NO", "Norway", "Norwegen"), C("FI", "Finland", "Finnland"), C("PL", "Poland", "Polen"),
  C("CZ", "Czech Republic", "Tschechien", ["czechia"]), C("PT", "Portugal", "Portugal"), C("GR", "Greece", "Griechenland"), C("HU", "Hungary", "Ungarn"),
  C("LU", "Luxembourg", "Luxemburg"), C("SK", "Slovakia", "Slowakei"), C("SI", "Slovenia", "Slowenien"), C("HR", "Croatia", "Kroatien"), C("RO", "Romania", "Rumänien"),
  C("BG", "Bulgaria", "Bulgarien"), C("RS", "Serbia", "Serbien"), C("LT", "Lithuania", "Litauen"), C("LV", "Latvia", "Lettland"), C("EE", "Estonia", "Estland"),
  C("IS", "Iceland", "Island"), C("TR", "Türkiye", "Türkei", ["turkey"]), C("UA", "Ukraine", "Ukraine"), C("CA", "Canada", "Kanada"), C("MX", "Mexico", "Mexiko"),
  C("BR", "Brazil", "Brasilien"), C("AR", "Argentina", "Argentinien"), C("JP", "Japan", "Japan"), C("KR", "South Korea", "Südkorea"), C("CN", "China", "China"),
  C("AU", "Australia", "Australien"), C("NZ", "New Zealand", "Neuseeland"), C("ZA", "South Africa", "Südafrika"), C("IL", "Israel", "Israel"), C("IN", "India", "Indien"),
  C("TH", "Thailand", "Thailand"), C("SG", "Singapore", "Singapur"), C("PH", "Philippines", "Philippinen"), C("JM", "Jamaica", "Jamaika"), C("CU", "Cuba", "Kuba"),
  C("MA", "Morocco", "Marokko"), C("EG", "Egypt", "Ägypten"), C("NG", "Nigeria", "Nigeria"), C("GH", "Ghana", "Ghana"), C("MT", "Malta", "Malta"), C("CY", "Cyprus", "Zypern"),
];

export const SPECIAL_FLAGS = [
  { code: "PIRATE", name: "Pirate", de: "Pirat", emoji: "🏴‍☠️" },
  { code: "RAINBOW", name: "Rainbow", de: "Regenbogen", emoji: "🏳️‍🌈" },
];

export function flagEmoji(code) {
  if (!code) return "";
  const sp = SPECIAL_FLAGS.find(s => s.code === code);
  if (sp) return sp.emoji;
  if (!/^[A-Z]{2}$/.test(code)) return "";
  return String.fromCodePoint(...[...code].map(c => 0x1f1e6 + c.charCodeAt(0) - 65));
}

export function countryToFlag(country) {
  const q = (country || "").trim().toLowerCase();
  if (!q) return null;
  if (/^[a-z]{2}$/.test(q) && COUNTRIES.some(c => c.code.toLowerCase() === q)) return q.toUpperCase();
  const hit = COUNTRIES.find(c => c.name.toLowerCase() === q || c.de.toLowerCase() === q || c.alt.includes(q));
  return hit ? hit.code : null;
}

export function flagOptions(lang) {
  return [...COUNTRIES.map(c => ({ code: c.code, label: lang === "de" ? c.de : c.name, emoji: flagEmoji(c.code), search: `${c.name} ${c.de} ${c.alt.join(" ")} ${c.code}`.toLowerCase() })),
    ...SPECIAL_FLAGS.map(s => ({ code: s.code, label: lang === "de" ? s.de : s.name, emoji: s.emoji, search: `${s.name} ${s.de}`.toLowerCase() }))];
}
